import styled from 'styled-components';
import ClientSideLink from './ClientSideLink';

export const UnstyledLink = styled(ClientSideLink)`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
